export type UserRole = 'admin' | 'operator' | 'noRole';

export enum UserRoleEnum {
  admin = 'admin',
  operator = 'operator',
}
